import {
    RaikoButtonSecondary, RaikoCustomTooltip, RaikoDivider, RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoLabelType
} from "@moeindal/base-raiko-panel-components";
import "./RaikoUploaderDrawer.scss"
import {useRaikoUploadManager} from "../RaikoUploadManagerContext";
import {RaikoUploaderStatus} from "../RaikoUploaderStatus";
import {getUploadedSize, RaikoConvertToHumanFileSize} from "../RaikoConvertToHumanFileSize";
import emptyList from "../img/vector-no-data.svg"
import mp4 from "../../../assets/svg/fileTypeIcon/mp4.svg";
import jpeg from "../../../assets/svg/fileTypeIcon/jpeg.svg";
import doc from "../../../assets/svg/fileTypeIcon/doc.svg";
import mp3 from "../../../assets/svg/fileTypeIcon/mp3.svg";
import android from "../../../assets/svg/fileTypeIcon/ic-android-file.svg";
import {css} from "@emotion/css";
import CircularProgress from "@mui/material/CircularProgress";
import icDone from "../../../assets/svg/ic-done.svg";
import icAborted from "../../../assets/svg/ic-close-white.svg";
import LinearProgress from '@mui/material/LinearProgress';

export default function RaikoUploaderDrawer({handleCloseUploadDrawer}) {

    const {uploads, cancelUpload, deleteItem, changeNotificationState} = useRaikoUploadManager()
    console.log("uploads", uploads)

    /*const task = {
        file, فایل در حال اپلود
        type, نوع فایل در حال اپلود از RaikoUploadFileTypes
        status: RaikoUploaderStatus.IN_PROGRESS, وضعیت اپلود در اینجا قرار دارد
        progress: 0, درصد پیشرفت در اینجا هست
        message: "" //خطا در اینجا برگشت داده میشه
    };*/


    return (
        <RaikoGridOneColumn className={"baseRaikoUploaderDrawerContainer"}>
            <RaikoFlexFirstChildGrowOne>
                <RaikoLabel text={"فایل های بارگذاری شده"} raikoLabelType={RaikoLabelType.TITLE}/>
                <div className={"ic-close"} onClick={handleCloseUploadDrawer}/>
            </RaikoFlexFirstChildGrowOne>

            <RaikoDivider/>
            {
                uploads && uploads.length > 0 ?
                    <div className={"fileMainLayout"}>
                        {
                            uploads.map((upload, index) => {
                                return <div
                                    className={`fileMainContainer
                                     ${upload.status === RaikoUploaderStatus.ABORTED
                                    ||
                                    upload.status === RaikoUploaderStatus.CANCELED ? "fileMainContainerAborted" : ""}`}>
                                    <div className={"fileIconContainer"}>
                                        <img
                                            className={css`width: 32px`}
                                            src={raikoUploaderFileIcons[upload.type]}
                                            alt={upload.type}
                                        />
                                        <div className={"fileTitleContainer"}>
                                            <span className={"fileTitle"}>{upload.file.name}</span>
                                            <RaikoFlexFirstChildGrowOne>
                                                <div className={"fileSizeContainer"}>
                                                    <span
                                                        className={"fileSize"}>
                                                        {RaikoConvertToHumanFileSize(upload.file.size)}
                                                    </span>
                                                    {
                                                        upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                            <span className={"fileSize"}>/</span>
                                                            :
                                                            <span className={"fileSize"}>-</span>
                                                    }
                                                    {
                                                        upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                            <span
                                                                className={"fileSize"}>
                                                            {RaikoConvertToHumanFileSize(getUploadedSize(upload.file.size, upload.progress))}
                                                        </span>
                                                            :
                                                            <span
                                                                className={raikoUploaderFileStatus[upload.status].className}>
                                                                {raikoUploaderFileStatus[upload.status].label}
                                                            </span>

                                                    }
                                                </div>
                                            </RaikoFlexFirstChildGrowOne>
                                            {
                                                upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                    <RaikoFlexFirstChildGrowOne className={css`width: 100%;
                                                        align-items: center`}>
                                                        <LinearProgress variant="determinate" value={upload.progress}/>

                                                    </RaikoFlexFirstChildGrowOne> : upload.status === RaikoUploaderStatus.ABORTED ?
                                                        <span className={raikoUploaderFileStatus.ABORTED.className}>
                                                            {upload.message}
                                                        </span> : ""
                                            }
                                        </div>
                                    </div>
                                    <div className={"fileStatusContainer"}>
                                        {upload.status === RaikoUploaderStatus.IN_PROGRESS ? <span
                                            className={`progressStyle`}>{upload.progress}%</span> : ""}
                                        {
                                            upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                <CircularProgress
                                                    size="20px"/> : upload.status === RaikoUploaderStatus.DONE ?
                                                    <div className={"icDoneContainer"}>
                                                        <img src={icDone} alt="ic-done"/>
                                                    </div> : upload.status === RaikoUploaderStatus.ABORTED || upload.status === RaikoUploaderStatus.CANCELED ?
                                                        <div className={"icAbortedContainer"}>
                                                            <img src={icAborted} alt="ic-aborted"/>
                                                        </div> : ""
                                        }
                                        {
                                            upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                <RaikoCustomTooltip title={"دریافت اعلان"}>
                                                    <div onClick={_ =>
                                                        changeNotificationState(upload.id, !upload.notification)
                                                    }
                                                         className={`ic-notification ${upload.notification ? "activeNotification" : ""}`}/>
                                                </RaikoCustomTooltip> : ""
                                        }


                                        {
                                            upload.status === RaikoUploaderStatus.IN_PROGRESS ?
                                                <RaikoCustomTooltip title={"لغو بارگذاری"}>
                                                    <div className={"ic-close"} onClick={_ => {
                                                        cancelUpload(upload.id)
                                                    }}/>
                                                </RaikoCustomTooltip>
                                                : <RaikoCustomTooltip title={"حذف از لیست"}>
                                                    <div className={"ic-trash"} onClick={_ => {
                                                        deleteItem(upload.id)
                                                    }}/>
                                                </RaikoCustomTooltip>
                                        }


                                    </div>

                                </div>
                            })
                        }
                    </div> :
                    <div className={"emptyList"}>
                        <img src={emptyList} alt="empty-list"/>
                        <span>فایلی جهت نمایش وجود ندارد</span>
                    </div>
            }

        </RaikoGridOneColumn>
    )
}

export const raikoUploaderFileStatus = {
    DONE: {
        className: "fileUploadSuccess",
        label: "انجام شد",
    },
    ABORTED: {
        className: "fileUploadAborted",
        label: "با خطا مواجه شد",
    },
    CANCELED: {
        className: "fileUploadAborted",
        label: "لغو شد",
    },
}
const raikoUploaderFileIcons = {
    APK: android,
    MUSIC: mp3,
    IMAGE: jpeg,
    VIDEO: mp4,
    DOCUMENT: doc,
}